import axios from 'axios';

const requests = axios.create({
    //根路径
    baseURL: "http://zz.whhzys.cn", //超时时间
    timeout: 5000
});
//请求拦截器
requests.interceptors.request.use((config) => {
    return config
});
//响应拦截器
requests.interceptors.response.use((res) => {
//成功的回调

    if (res.status == 200 && res.data.code == 200) {
        return Promise.resolve(res.data)
    } else {
        return Promise.reject('系统错误,请稍后再试！')
    }

}, (error) => {
//失败的回调
    console.log("失败", error.message);
})
export default requests;